import { useSyncExternalStore } from 'react';

export type ToastKind = 'ok' | 'err' | 'info' | 'warn';
export interface ToastItem {
  id: number;
  kind: ToastKind;
  text: string;
}

let items: ToastItem[] = [];
let nextId = 1;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function toast(text: string, kind: ToastKind = 'info', ms = 4500): void {
  const id = nextId++;
  items = [...items, { id, kind, text }];
  emit();
  setTimeout(() => {
    items = items.filter((t) => t.id !== id);
    emit();
  }, ms);
}

export function useToasts(): ToastItem[] {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => items,
  );
}
